export default [
  {
    group: '',
    model: false,
    icon: 'mdi-home-outline',
    title: 'Dashboards',
    active: false,
    permission: 'dashboard-view',
    children: [
      {
        title: 'Dashboard',
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'dashboard-main',
        permission: 'dashboard-main-view'
      },
      // {
      //   title: 'Notificações',
      //   icon: 'mdi-checkbox-blank-circle-outline',
      //   to: 'notifications',
      //   permission: 'notification-view'
      // }
    ],
  },
  {
    group: '',
    model: false,
    icon: 'mdi-hexagon-outline',
    title: 'Gestão',
    active: false,
    permission: 'management-view',
    children: [
      {
        title: 'Clientes',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'clients',
        permission: 'clients-view'
      },
      {
        title: 'Organograma',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'entitiesTree',
        permission: 'entities-view'
      },
      {
        title: 'Etiquetas',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'labels',
        permission: 'labels-view'
      },
      {
        title: 'Perfil',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'countersign',
        permission: 'profile-view'
      },
      {
        title: 'Cargo',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'positions',
        permission: 'positions-view'
      },
      {
        title: 'Departamento',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'entities',
        permission: 'entities-view'
      },
    ],
  },
  {
    active: true,
    to: '/documents',
    icon: 'mdi-format-list-bulleted',
    title: 'Documentos',
    permission: 'document-view',
  },
  {
    group: '',
    model: false,
    active: false,
    icon: 'mdi-lock-outline',
    title: 'Sistema',
    permission: 'system-view',
    children:[
      {
        title: 'Administradores',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'administrators',
        permission: 'administrators-view'
      },
      {
        title: 'Gestores',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'managers',
        permission: 'managers-view'
      },
      {
        title: 'Operadores',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'operators',
        permission: 'operators-view'
      },
      {
        title: 'Perfil',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'roles',
        permission: 'roles-view'
      },
      {
        title: 'Permissões',
        active: false,
        icon: 'mdi-checkbox-blank-circle-outline',
        to: 'permissions',
        permission: 'permissions-view'
      }
    ]
  }
]